import React from "react";

interface OwnProps {
    onSearch: (query: string) => void;
    query?: string;
}

interface OwnState {
    query: string;
}

export class SearchBox extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            query: "",
        };
    }

    public componentDidMount() {
        this.setState({ ...this.state, query: this.props.query || "" });
    }

    public componentWillReceiveProps(nextProps: OwnProps) {
        if (nextProps.query !== this.props.query)
            this.setState({ ...this.state, query: nextProps.query || "" });
    }

    public render() {
        return <div id="dedicated-search">
            <h2>Search</h2>
            <div className="search">
                <input
                    className="search-txt"
                    name="q"
                    title="Search"
                    placeholder="Job title or keyword&hellip;"
                    value={this.state.query || ""}
                    onChange={(e) => this.onSearchChange(e)}
                />
                <button aria-label="Go" className="search-button" type="submit"><i aria-hidden="true" className="fa fa-search"></i></button>
            </div>
        </div>;
    }

    private onSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
        const query = (e.target as HTMLInputElement).value;
        this.setState({ ...this.state, query });
        this.props.onSearch(query);
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/components/SearchBox.tsx